var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column-fluid flex-center mt-12"},[_c('a',{staticClass:"text-center mb-10",attrs:{"href":"#"}},[_c('img',{staticClass:"max-h-200px",attrs:{"src":"media/novaImagens/logo.png","alt":""}})])])])])])
}]

export { render, staticRenderFns }